module.exports = solid["auth"];